import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';

import {
  Card, BlockStack, InlineStack, Text, Button, TextField,
} from '@shopify/polaris';
import { CheckIcon } from '@shopify/polaris-icons';

import { cartLayoutFind, cartLayoutUpdate } from '../../redux/actions/cartLayouts';
import { DEFAULT_CART_LAYOUT_ID } from '../../constants';

const UpdateCartLayoutForm = ({ cartLayouts, newCartLayout, loadCartLayout, updateCartLayout }) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const [label, setLabel] = useState('');
  const [rows, setRows] = useState(1);
  const [columns, setColumns] = useState(1);
  const [maxItemsPerTote, setMaxItemsPerTote] = useState('');

  useEffect(() => {
    loadCartLayout(id);
  }, [id, loadCartLayout]);

  useEffect(() => {
    if(newCartLayout) { navigate(-1) };
  }, [newCartLayout, navigate]);

  useEffect(() => {
    if(cartLayouts.activeCartLayout) {
      setLabel(cartLayouts.activeCartLayout.label);
      setRows(cartLayouts.activeCartLayout.rows);
      setColumns(cartLayouts.activeCartLayout.columns);
      setMaxItemsPerTote(cartLayouts.activeCartLayout.max_items_per_tote || '');
    }
  }, [cartLayouts]);

  const submitCartLayout = () => {
    updateCartLayout(id, label, rows, columns, maxItemsPerTote);
  }

  const description = "Have questions or need some help? Contact us at support@athousandapps.com";

  if(id === DEFAULT_CART_LAYOUT_ID) {
    return (
      <SettingsPage title="Update Cart Layout" description={description}>
        <Card>
          <BlockStack gap="200">
            <Text as="h2" variant="headingMd">Update Cart Layout</Text>
            <Text as="p">The default cart layout is built in and cannot be edited.</Text>
          </BlockStack>
        </Card>
      </SettingsPage>
    )
  }

  if(!cartLayouts.activeCartLayout) {
    return (
      <SettingsPage title="Update Cart Layout" description={description}>
        <Card>
          <BlockStack gap="200">
            <Text as="h2" variant="headingMd">Update Cart Layout</Text>

            <LoadingSpinner size="small" statusText="Loading cart layout" />
          </BlockStack>
        </Card>
      </SettingsPage>
    )
  }


  return(
    <SettingsPage title="Update Cart Layout" description={description}>
      <Card>
        <BlockStack gap="400">
          <Text as="h2" variant="headingMd">Update Cart Layout</Text>

          <TextField
            requiredIndicator
            label="Cart Layout Name"
            placeholder="Cart Layout Name"
            value={label}
            onChange={setLabel}
            autoComplete="off"
          />

          <TextField
            requiredIndicator
            label="Rows"
            placeholder="Rows"
            type="number"
            min={1}
            value={String(rows)}
            onChange={(value) => setRows(parseInt(value) || 1)}
            autoComplete="off"
          />

          <TextField
            requiredIndicator
            label="Columns"
            placeholder="Columns"
            type="number"
            min={1}
            value={String(columns)}
            onChange={(value) => setColumns(parseInt(value) || 1)}
            autoComplete="off"
          />

          <TextField
            label="Max Items per Tote"
            placeholder="Unlimited"
            type="number"
            min={1}
            value={String(maxItemsPerTote)}
            onChange={setMaxItemsPerTote}
            autoComplete="off"
          />
        </BlockStack>
      </Card>

      <Card>
        <InlineStack align="start">
          <Button
            variant="primary"
            icon={CheckIcon}
            onClick={() => submitCartLayout() }
          >
            Update Cart Layout
          </Button>
        </InlineStack>
      </Card>
    </SettingsPage>
  )
}

const mapStateToProps = state => ({
  cartLayouts: state.cartLayouts,
  newCartLayout: state.cartLayouts.newCartLayout,
});

const mapDispatchToProps = (dispatch) => ({
  loadCartLayout: (id) => dispatch(cartLayoutFind(id)),
  updateCartLayout: (id, label, rows, columns, maxItemsPerTote) => dispatch(cartLayoutUpdate(id, label, rows, columns, maxItemsPerTote)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCartLayoutForm);
